import { TelegramAPISettings } from '../telegram_api_settings.js';

/** What Telegram.WebApp.openInvoice reports when its payment sheet closes. */
export type TelegramInvoiceStatus = 'paid' | 'cancelled' | 'failed' | 'pending';

// productId -> price in Stars, filled from the offers list. The IAP facade
// reads it to draw "⭐ N" on buttons without knowing about offers.
const prices_by_product = new Map<string, number>();

function getWebApp(): any
{
  return ( window as any )?.Telegram?.WebApp ?? null;
}

function isNativeApp(): boolean
{
  const platform = ( window as any )?.Capacitor?.getPlatform?.();
  return platform === 'android' || platform === 'ios';
}

export const TelegramStars = {
  /** Inside a Telegram Mini App whose client can open invoices (Bot API 6.1+). */
  isAvailable(): boolean
  {
    if ( isNativeApp() ) return false;
    const webapp = getWebApp();
    return !!webapp
      && typeof webapp.openInvoice === 'function'
      && TelegramAPISettings.isTelegramEnvironment()
      && typeof webapp.isVersionAtLeast === 'function'
      && webapp.isVersionAtLeast( '6.1' );
  },

  rememberPrice( product_id: string, price_stars: number ): void
  {
    if ( product_id && Number.isInteger( price_stars ) && price_stars > 0 ) prices_by_product.set( product_id, price_stars );
  },

  getPrice( product_id: string ): number | null
  {
    return prices_by_product.get( product_id ) ?? null;
  },

  formatPrice( price_stars: number ): string
  {
    return `⭐ ${price_stars}`;
  },

  /**
   * Opens Telegram's payment sheet. "paid" only means the sheet says so:
   * the server learns about the payment from the bot webhook, so the caller
   * still polls the order until the server has granted it.
   */
  openInvoice( invoice_link: string ): Promise<TelegramInvoiceStatus>
  {
    const webapp = getWebApp();
    if ( !webapp?.openInvoice ) return Promise.reject( new Error( 'telegram_invoice_unavailable' ) );

    return new Promise( ( resolve, reject ) =>
    {
      try
      {
        webapp.openInvoice( invoice_link, ( status: string ) =>
        {
          resolve( status === 'paid' || status === 'cancelled' || status === 'failed' ? status : 'pending' );
        } );
      }
      catch ( e )
      {
        reject( e );
      }
    } );
  },
};
